import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, share } from 'rxjs';
import { IPvsTaskInfo } from '../interfaces/pvs-task.interface';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class PvsTaskApiService {
  private readonly httpClient = inject(HttpClient);

  public getPvsTaskInfo(): Observable<IPvsTaskInfo> {
    return this.httpClient
      .get<IPvsTaskInfo>(
        `${environment.API_URL}/dispatching/disruption/pvs/task/info`,
      )
      .pipe(share());
  }

  public setPvsTaskAccept(taskId: number): Observable<unknown> {
    return this.httpClient
      .get(
        `${environment.API_URL}/dispatching/disruption/pvs/task/${taskId}/accept`,
      )
      .pipe(share());
  }

  public setPvsTaskOnWay(taskId: number): Observable<unknown> {
    return this.httpClient
      .get(
        `${environment.API_URL}/dispatching/disruption/pvs/task/${taskId}/way`,
      )
      .pipe(share());
  }

  public setPvsTaskAtObject(taskId: number): Observable<unknown> {
    return this.httpClient
      .get(
        `${environment.API_URL}/dispatching/disruption/pvs/task/${taskId}/object`,
      )
      .pipe(share());
  }

  public setPvsTaskInProgress(taskId: number): Observable<unknown> {
    return this.httpClient
      .get(
        `${environment.API_URL}/dispatching/disruption/pvs/task/${taskId}/progress`,
      )
      .pipe(share());
  }

  public setPvsTaskComplete(taskId: number): Observable<unknown> {
    return this.httpClient
      .get(
        `${environment.API_URL}/dispatching/disruption/pvs/task/${taskId}/complete`,
      )
      .pipe(share());
  }

  public setPvsTaskCancel(taskId: number): Observable<unknown> {
    return this.httpClient
      .get(
        `${environment.API_URL}/dispatching/disruption/pvs/task/${taskId}/cancel`,
      )
      .pipe(share());
  }
}
